// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"9314b95e","289":"2ca97fb1","831":"7741feeb","871":"2749cd87","917":"9eb9cc97"}[chunkId] + ".chunk.css";
};